const colors = {
    PRIMARY_DISABLED: '#d8e3f6',
    PRIMARY_HOVER: '#6e9be8',
    PRIMARY_LIGHTER: '#e6efff',
    PRIMARY_LIGHTER_O40: 'rgba(230, 239, 255, 0.4)',
    PRIMARY_LIGHTER_O60: 'rgba(230, 239, 255, 0.6)',
    PRIMARY_LIGHTER_20: '#fafcff',
    PRIMARY_LIGHTER_40: '#f5f9ff',
    PRIMARY_LIGHTER_OP20: 'rgba(230, 239, 255, 0.2)',
    PRIMARY_LIGHTER_OP40: 'rgba(230, 239, 255, 0.4)',
    PRIMARY_LIGHT: '#ccdfff',
    PRIMARY_DEFAULT: '#5087e6',
    PRIMARY_DARK: '#366ab3',
    PRIMARY_DARKER: '#143666',
    BLUE_LIGHTER: '#ebf7ff',
    BLUE_LIGHT: '#d1eeff',
    BLUE_DEFAULT: '#b4e0fa',
    BLUE_DARK: '#48a8e0',
    BLUE_DARKER: '#1b577a',
    GREEN_DISABLED: '#deede9',
    GREEN_HOVER: '#6db8a3',
    GREEN_LIGHT: '#6db7a0',
    GREEN_LIGHTER: '#d5f7eb',
    GREEN_DEFAULT: '#4fab8c',
    GREEN_DARK: '#349172',
    GREEN_DARKER: '#195e47',
    YELLOW_DISABLED: '#faf1df',
    YELLOW_HOVER: '#f9cf75',
    YELLOW_LIGHTER: '#fff9ed',
    YELLOW_LIGHT: '#ffe1a1',
    YELLOW_DEFAULT: '#ffc853',
    YELLOW_DARK: '#f7b425',
    YELLOW_DARKER: '#665022',
    RED_LIGHTER: '#fae4e1',
    RED_LIGHT: '#ffa599',
    RED_DEFAULT: '#e68173',
    RED_DARK: '#cc6152',
    RED_DARKER: '#803126',
    SKY_LIGHT: '#f9fafb',
    SKY_DEFAULT: '#e6eaf0',
    SKY_DARK: '#d3dde6',
    SKY_DARK_O60: 'rgba(211, 221, 230, 0.6)',
    CANVAS: '#edeef0',
    INK_HOVER: '#474f5e',
    INK_LIGHTEST: '#b8becc',
    INK_LIGHTER: '#7a8499',
    INK_LIGHT: '#596480',
    INK_DEFAULT: '#363d4d',
    INK_PANEL_LIGHT: '#474e5f',
    SNOW_DISABLED: '#f7f7f7',
    SNOW_HOVER: '#f5f7fb',
    SNOW_LIGHT: '#fff',
    SNOW_LIGHT_O60: 'rgba(255, 255, 255, 0.6)',
    SNOW_LIGHT_HOVER: '#f8fafd',
    SNOW_DEFAULT: '#fafafa',
    SNOW_DARK: '#f7f7f7',
    SHADOW_DEFAULT: 'rgba(54, 62, 81, 0.1)',
    SHADOW_LIGHT: 'rgba(54, 62, 81, 0.05)',
    SHADOW_DARK: 'rgba(54, 62, 81, 0.2)',
    TRANSPARENT: 'transparent',
    BLACK: '#000',
    SNOW_100: '#ffffff',
    SNOW_200: '#fafafa',
    SNOW_300: '#f9fafb',
    SNOW_400: '#f7f7f7',
    SNOW_500: '#edeef0',
    SNOW_A200: 'rgba(255, 255, 255, 0.2)',
    SNOW_A400: 'rgba(255, 255, 255, 0.4)',
    SNOW_A600: 'rgba(255, 255, 255, 0.6)',
    SNOW_A800: 'rgba(255, 255, 255, 0.8)',
    SNOW_A900: 'rgba(255, 255, 255, 0.9)',
    INK_200: '#e6eaf0',
    INK_300: '#d3dde6',
    INK_400: '#b8becc',
    INK_500: '#7a8499',
    INK_600: '#596480',
    INK_700: '#474f5e',
    INK_800: '#363d4d',
    INK_900: '#242833',
    INK_A50: 'rgba(54, 62, 81, 0.05)',
    INK_A100: 'rgba(54, 62, 81, 0.1)',
    INK_A200: 'rgba(54, 62, 81, 0.2)',
    INK_A400: 'rgba(54, 62, 81, 0.4)',
    INK_A500: 'rgba(54, 62, 81, 0.5)',
    INK_A600: 'rgba(54, 62, 81, 0.6)',
    INK_A800: 'rgba(54, 62, 81, 0.8)',
    PRIMARY_100: '#fafcff',
    PRIMARY_200: '#f2f7ff',
    PRIMARY_300: '#e6efff',
    PRIMARY_400: '#ccdfff',
    PRIMARY_500: '#6e9be8',
    PRIMARY_600: '#5087e6',
    PRIMARY_700: '#366ab3',
    PRIMARY_900: '#143666',
    PRIMARY_A200: 'rgba(230, 239, 255, 0.2)',
    PRIMARY_A400: 'rgba(230, 239, 255, 0.4)',
    PRIMARY_A600: 'rgba(230, 239, 255, 0.6)',
    PRIMARY_A800: 'rgba(230, 239, 255, 0.8)',
    RED_200: '#fff3f2',
    RED_300: '#fae4e1',
    RED_400: '#eaaba4',
    RED_500: '#ffa599',
    RED_600: '#e68173',
    RED_700: '#cc6152',
    RED_900: '#803126',
    GREEN_100: '#eefcf7',
    GREEN_200: '#d5f7eb',
    GREEN_300: '#deede9',
    GREEN_400: '#a9decc',
    GREEN_500: '#96cbbe',
    GREEN_600: '#4fab8c',
    GREEN_700: '#349172',
    GREEN_900: '#195e47',
    BLUE_200: '#ebf7ff',
    BLUE_400: '#d1eeff',
    BLUE_600: '#b4e0fa',
    BLUE_700: '#48a8e0',
    BLUE_800: '#2989C1',
    BLUE_900: '#1b577a',
    YELLOW_200: '#fff9ed',
    YELLOW_300: '#faf1df',
    YELLOW_400: '#ffe1a1',
    YELLOW_500: '#f7d181',
    YELLOW_600: '#ffc853',
    YELLOW_700: '#f7b425',
    YELLOW_800: '#d59201',
    YELLOW_900: '#665022',
};
export default colors;
//# sourceMappingURL=colors.js.map